function ab_testing_redirectToVariant(ab_testing_case) {
    let current_url = window.location.href.split(/[?#]/)[0];
    if (current_url.replace(/\/$/, '') !== ab_testing_case.url.replace(/\/$/, '')) {
        return;
    }

    const keys = [
        ab_testing_case.variant_a,
        ab_testing_case.variant_b
    ];
    let json = JSON.parse(localStorage.getItem("ab_testing_cases"));
    if (json === null) {
        json = [];
    }
    let variant = null;
    for (let str of json) {
        if (str.split('-')[1] === ab_testing_case.id) {
            variant = parseInt(str.split('-')[2]);
            break;
        }
    }
    if (variant === null) {
        variant = Math.floor(Math.random() * keys.length) + 1;
        json.push(ab_testing_case.website + '-' + ab_testing_case.id + '-' + String(variant).padStart(7, '0'));
        localStorage.setItem("ab_testing_cases", JSON.stringify(json));
    }

    if (current_url.replace(/\/$/, '') !== keys[variant - 1].replace(/\/$/, '')) {
        window.location.href = keys[variant - 1] + (window.location.href.match(/[?#].*/)?.[0] || '');
    }
}

fetch("//www.honeyflow.com/cdn/shop/t/10/assets/ab_testing_config.js?v=39558405666954417361764236048")
  .then(response => response.text())
  .then(data => {
    data = data.replace(/\/\*[\s\S]*?\*\//g, '');
    const ab_testing_config = JSON.parse(data);

    if (!ab_testing_config || !ab_testing_config.experiments) {
        return;
    }

    for (let ab_testing_case of ab_testing_config.experiments) {
        if (!ab_testing_case.website || !ab_testing_case.id) {
            continue;
        }
    
        ab_testing_redirectToVariant(ab_testing_case);
    }
  });
